import styles from "./index.module.scss";
import type { TTemplate } from "@/types";
import clsx from "clsx";
import { MouseEventHandler, useState } from "react";
import FTAnalytic from "@/analyze/FTAnalytic";
import { PROJECT_TYPE, TagType } from "@/constants";
import { Tag } from "@/components";

type TemplateProps = {
  className?: string;
  isActive?: boolean;
  initWidth?: number;
  initHeight?: number;
  onClick: MouseEventHandler<HTMLDivElement>;
  onLoad?:(size:{width:number,height:number})=>void;
} & TTemplate;

const Template = (props: TemplateProps) => {
  const {
    className,
    isActive,
    onClick,
    id,
    thumbnail,
    tag,
    onLoad,
    initWidth= 1,
    initHeight= 1,
  } = props;

  const [loaded, setLoaded] = useState(false);
  const [size,setSize] = useState({width:initWidth,height:initHeight});
  const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    // 埋点（点击）
    FTAnalytic.addAnalytic({
      type: 'ev',
      action: 'fotor_web$click_up$swap_project_page_features',
      label: {
        button_position: id,
        project_type: PROJECT_TYPE,
      },
    });

    onClick(e);
  }

  return (
    <div
      className={clsx(
        styles["template"],
        isActive && styles["active"],
        className,
      )}
      style={{
        aspectRatio: `${size.width} / ${size.height}`
      }}
    >
      <img 
        className={styles["thumbnail"]}
        src={thumbnail}
        alt=""
        onLoad={(e) => {
          setLoaded(true);
          setSize({
            width: e.currentTarget.naturalWidth,
            height: e.currentTarget.naturalHeight
          });
          onLoad?.({
            width: e.currentTarget.naturalWidth,
            height: e.currentTarget.naturalHeight
          });
        }}
        onClick={handleClick}
      />

      {loaded ? (
        <>
          {(tag && [TagType.HOT, TagType.NEW].includes(tag)) && (
            <Tag
              className={styles["custom_tag"]}
              type={tag}
            ></Tag>
          )}
        </>
      ) : (
        <div
          className={clsx(
            styles["skeleton"],
            "skeleton_loading"
          )}
        ></div>
      )}
    </div>
  )
}

export default Template;